<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ t('consultants::page.title.consultants') }}</h2>
            <consultants-data-table :list-route="listRoute" :initial-filters="initialFilters"></consultants-data-table>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            initialFilters: {
                is_registered: null,
            },
        };
    },
    methods: {},
};
</script>
